import type { SupervisorActivitySearch } from '@/features/supervisor/types/supervisor';

/**
 * Applies an organization/project scope chosen by a navigation control.
 * Organization-bound filters are retained only when the organization is unchanged.
 */
export function supervisorActivityScopeSearch(
  search: SupervisorActivitySearch,
  organizationId?: string,
  projectId?: string,
): SupervisorActivitySearch {
  const sameOrganization = organizationId
    ? search.organizationId?.length === 1 && search.organizationId[0] === organizationId
    : !search.organizationId?.length;

  return {
    ...search,
    organizationId: organizationId ? [organizationId] : undefined,
    projectId,
    runner: sameOrganization ? search.runner : undefined,
    opsCode: sameOrganization ? search.opsCode : undefined,
    operatorId: sameOrganization ? search.operatorId : undefined,
    environmentId: sameOrganization ? search.environmentId : undefined,
  };
}
